import * as React from 'react';
import classNames from 'classnames';
import Icon, { IconsAvailable } from '../Icon';
import Button, {IButtonProps} from '../Button';
import Buttons from '../Buttons';
import {PropsWithChildren, useEffect} from 'react';

interface INotificationIconProps extends PropsWithChildren {
    file: string;
    size?: 'small' | 'large' | 'default';
    alt?: string;
}
export interface ISystemNotificationProps extends PropsWithChildren {
    icon?: INotificationIconProps;
    hideIcon?: boolean;
    iconPath?: string;
    iconAlt?: string;
    iconSize?: 'small' | 'large' | 'default';
    closable?: boolean;
    labelClose?: string;
    onClose?: () => {};
    intent?: 'success' | 'warn' | 'danger' | 'info' | 'discrete';
    actions?: IButtonProps[];
    align?: 'left' |'center' | 'right';
    testId?: string;
    className?: string;
}

const SystemNotification: React.FunctionComponent<ISystemNotificationProps> = (props) => {
    let defaultIcon:IconsAvailable = 'epharma-warn';
    const [visible, setVisible] = React.useState(true);
    if (props.intent === 'success') { defaultIcon = 'epharma-check'; }

    useEffect(() => {
        setVisible(true);
    }, [props]);

    if (!visible) {
        return null;
    }

    return (
        <li className={classNames('system-notification', props.intent && props.intent, props.align && props.align, props.className)} role="alert"
            data-testid={props.testId}
        >
            <div className="system-notification__inner">
                {!props.hideIcon && (
                    <div
                        className={classNames('system-notification__icon', (props.iconSize || props.icon) ? 'size-' + props.icon?.size ?? props.iconSize : 'size-small')}>
                        {(props.iconPath || props.icon) ? (
                            <img
                                src={props.icon?.file ?? props.iconPath}
                                alt={props.icon?.alt ?? props.iconAlt}
                            />
                        ) : !props.hideIcon && props.intent && (
                            <Icon
                                kind={defaultIcon}
                                width={20}
                                height={20}
                            />
                        )}
                    </div>
                )}

                <div className="system-notification__content">
                    {props.children}
                </div>
                {props.actions && (
                    <div className="system-notification__actions">
                        <Buttons>
                            {props.actions.map((button, i) => {
                                return (<Button key={i} {...button}/>);
                            })}
                        </Buttons>
                    </div>
                )}
                {props.closable && (
                    <button className="system-notification__close" type="button" onClick={() => {
                        setVisible(false);
                        if (props.onClose) {
                            props.onClose();
                        }
                    }}>
                        <Icon kind="epharma-cross" width={16} height={16}/>{props.labelClose ? props.labelClose : 'Sulge'}
                    </button>
                )}
            </div>
        </li>
    );
};

SystemNotification.displayName = 'SystemNotification';

export default SystemNotification;
